import { render, staticRenderFns, recyclableRender, components } from "./u-form-item.vue?vue&type=template&id=5e7216f1&scoped=true&"
var renderjs
import script from "./u-form-item.vue?vue&type=script&lang=js&"
export * from "./u-form-item.vue?vue&type=script&lang=js&"
import style0 from "./u-form-item.vue?vue&type=style&index=0&id=5e7216f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7216f1",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "node_modules/uview-ui/components/u-form-item/u-form-item.vue"
export default component.exports